import { render, staticRenderFns } from "./deliveryDestinationList.vue?vue&type=template&id=c67bc172&"
import script from "./deliveryDestinationList.vue?vue&type=script&lang=ts&"
export * from "./deliveryDestinationList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports